import { Button } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

interface IResetFiltersButtonProps {
  onReset: () => void
}

function ResetFiltersButton(props: IResetFiltersButtonProps) {
  const { onReset } = props
  const { t } = useTranslation()

  return (
    <Button
      variant="contained"
      disableElevation={true}
      onClick={onReset}
      sx={{
        backgroundColor: 'divider',
        '&:hover': { backgroundColor: 'grey.400' },
        color: '#000',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '17px',
        fontStyle: 'normal',
        textTransform: 'none',
        opacity: 0.6,
      }}
    >
      {t('Reset filters')}
    </Button>
  )
}

export default ResetFiltersButton
